import React from 'react';
import { ErrorLayout, MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { getBlogPage } from '@modules/get-data';
import { PROCESSING_ITEMS } from '@constants';
import { BlogArticlePage } from '@sections/Blog-Article-Page';
import { ErrorStub } from '@components/Error-Stub';
import { getErrorContent, redirect, SendLog } from '@libs';

const BlogArticle = ({ content, popular, comments }) => (
  <BlogArticlePage content={content} popular={popular} comments={comments} />
);

BlogArticle.getLayout = (page, { content, alternateLinks, statusCode }) => {
  const { translations } = page.props;

  if (statusCode) {
    const error = getErrorContent({ code: statusCode });

    return (
      <ErrorLayout title={translations.t(error.title)}>
        <ErrorStub error={error} />
      </ErrorLayout>
    );
  }

  return (
    <MainLayout
      title={content.title}
      description={content.description}
      keywords={content.title}
      alternateLinks={alternateLinks}
      processing={PROCESSING_ITEMS.GET_BLOG_PAGE}>
      {page}
    </MainLayout>
  );
};

BlogArticle.getInitialProps = async ({ req, res, query, store: { dispatch, getState } }) => {
  const {
    settings: { locale },
  } = getState();

  const redirectUrls = [
    [
      ['instructions', 'sozdanie-obmernogo-plana-v-planoplan'],
      ['instructions', 'obmernyj-plan-v-planoplan'],
    ],
  ];

  const urls = redirectUrls.find((item) => item[0][1] === query.url[0]);

  if (urls) {
    return redirect(`/${locale}/blog/${urls[1][0]}/${urls[1][1]}`, {}, 301, res);
  }

  if (query.url[0] === 'zagruzka-3d-modelej-v-planoplan') {
    const userAgent =
      req?.headers?.['user-agent'] || (typeof navigator !== 'undefined' ? navigator.userAgent : 'Unknown');
    const referer =
      req?.headers?.['referer'] ||
      req?.headers?.['referrer'] ||
      (typeof document !== 'undefined' ? document.referrer : 'Direct') ||
      'Direct';
    const ip =
      req?.headers?.['x-forwarded-for']?.split(',')[0]?.trim() ||
      req?.connection?.remoteAddress ||
      req?.socket?.remoteAddress ||
      'Unknown';

  }

  const blogPageData = await dispatch(getBlogPage(query));
  const { errors } = getState();
  const error = errors[PROCESSING_ITEMS.GET_BLOG_PAGE];

  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { ...blogPageData, statusCode: error.code };
  }

  return blogPageData;
};

export default withUser(BlogArticle);
